import { render, staticRenderFns } from "./UserGeneral.vue?vue&type=template&id=326f6623"
import script from "./UserGeneral.vue?vue&type=script&lang=js"
export * from "./UserGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports